import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 20l14 0","key":"svg-0"}],["path",{"d":"M5 17h5v-.3a7 7 0 1 1 4 0v.3h5","key":"svg-1"}]]

const IconZodiacLibra = createReactComponent('outline', 'zodiac-libra', 'ZodiacLibra', __iconNode);

export default IconZodiacLibra;